import styled from "styled-components";

const DeliveryRoutesPageStyled = styled.div`

`;

export default DeliveryRoutesPageStyled;